import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
/* This Error component is inspired by the OktaError found here:
https://github.com/okta/okta-react/blob/master/src/OktaError.tsx
*/
export const ErrorWrapper = ({ error }) => {
    const properError = error.name && error.message;
    return (_jsx("p", { children: properError
            ? `${error.name} ${error.message}`
            : `Error: ${error.toString()}` }));
};
//# sourceMappingURL=error-wrapper.js.map